/* eslint-disable jira/filename-case */
import { useCallback } from 'react';

import { graphql, useMutation } from 'react-relay';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import type {
	useBoardCreateMutationUseBoardCreateMutation$data as useBoardCreateMutationData,
	useBoardCreateMutationUseBoardCreateMutation as useBoardCreateMutationQuery,
	JiraCreateBoardInput,
} from './__generated__/useBoardCreateMutationUseBoardCreateMutation.graphql.ts';

export const useBoardCreateMutationUseBoardCreateMutation = (): {
	handleMutation: (input: JiraCreateBoardInput) => Promise<useBoardCreateMutationData>;
} => {
	const cloudId = useCloudId();

	const [commit] = useMutation<useBoardCreateMutationQuery>(graphql`
		mutation useBoardCreateMutationUseBoardCreateMutation(
			$cloudId: ID!
			$input: JiraCreateBoardInput!
		) {
			jira @optIn(to: ["JiraCreateBoard"]) {
				createBoard(cloudId: $cloudId, input: $input) {
					board {
						__id
						boardId
						name
						id
						boardType
						boardUrl
					}
					success
					errors {
						message
						extensions {
							errorType
							statusCode
						}
					}
				}
			}
		}
	`);

	const handleMutation = useCallback(
		async (input: JiraCreateBoardInput): Promise<useBoardCreateMutationData> =>
			new Promise((resolve, reject) => {
				commit({
					variables: {
						cloudId,
						input,
					},
					onCompleted: (result) => {
						resolve(result);
					},
					onError: (error) => {
						reject(error);
					},
				});
			}),
		[cloudId, commit],
	);

	return { handleMutation };
};
